/**
 * Api errors reported by the File controller
 */
export var FileErrorCode;
(function (FileErrorCode) {
    /**
     * A file with the same name and checksum was already successfully uploaded in the same court system
     */
    FileErrorCode["FileAlreadyUploadedError"] = "TrmAlreadyUploadedError";
    /**
     * An attempt was made to finalize a file that has already been finalized.
     */
    FileErrorCode["FileAlreadyFinalizedError"] = "FileAlreadyFinalizedError";
    /**
     * An attempt was previously made to upload a file with the same name but different checksum in this court system
     */
    FileErrorCode["FileInvalidChecksumError"] = "TrmInvalidChecksumError";
    /**
     * An attempt was made to remove files that were not from the same recording
     * (i.e. different or unknown recorders or dates)
     */
    FileErrorCode["FilesToRemoveAreNotFromSameRecordingError"] = "FilesToRemoveAreNotFromSameRecordingError";
    /**
     * Indicates an attempt to upload a file which has been marked as sealed
     * @deprecated Pending ftr-cloud-sync agents all being updated to version 1.6.0
     */
    FileErrorCode["CannotUploadSealedFile"] = "file/CannotUploadSealedFile";
    /**
     * Indicates an attempt to upload a file which has been marked as removed
     */
    FileErrorCode["CannotUploadRemovedFile"] = "file/CannotUploadRemovedFile";
    /**
     * The object checksum provided for the request does not match the object checksum of the impacted items
     */
    FileErrorCode["NonmatchingObjectChecksum"] = "file/NonmatchingObjectChecksum";
    /**
     * Given the provided removal parameters, no items would be removed
     */
    FileErrorCode["NoRemovalItemsFound"] = "file/NoRemovalItemsFound";
})(FileErrorCode || (FileErrorCode = {}));
